import { parseAsArrayOf, parseAsString } from 'nuqs';

/**
 * Filter URL keys = column ids. API param names diverge (`rating` →
 * `carbonIntensityCategory`); the page maps them when building the request.
 */
export enum GroupPackagingFilterColumn {
  Search = 'name',
  Rating = 'rating',
  Supplier = 'supplier',
}

const arrayOfStrings = parseAsArrayOf(parseAsString).withDefault([]);

export const groupPackagingFilters = {
  [GroupPackagingFilterColumn.Search]: { type: parseAsString },
  [GroupPackagingFilterColumn.Rating]: { type: arrayOfStrings },
  [GroupPackagingFilterColumn.Supplier]: { type: arrayOfStrings },
} as const;
